import React from 'react';
import MessageLayout from '../../components/domain/MessageLayout';
import { PageHeader } from '../../components/ui/Primitives';
import { useAuth } from '../../context/AuthContext';
import { useData } from '../../context/DataContext';

export default function StudentMessaging() {
  const { user } = useAuth();
  const { messages = [], users = [], addMessage, updateMessage, loading = false } = useData() || {};
  return <div><PageHeader eyebrow="Inbox" title="Messages" description="Direct conversations with your lecturers and the School of SHEM team." /><MessageLayout currentUser={user} role="student" messages={messages} users={users} addMessage={addMessage} updateMessage={updateMessage} recipientRoles={['teacher', 'admin']} loading={loading} /></div>;
}
